<template>
    <div class="carBox carBoxLeft">
        <div class="newBox">
            <div class="searchBox">
                <div class="searchGroup">
                    <label>选择日期：</label>
                    <el-date-picker v-model="folder" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
                </div>
                <div class="searchGroup">
                    <label>时间段：</label>
                    <el-time-picker is-range v-model="dateRange" value-format="HH:mm:ss"
                        range-separator="至"
                        start-placeholder="开始时间"
                        end-placeholder="结束时间"
                        placeholder="选择时间范围"
                        @change="dateRangeSet">
                    </el-time-picker>
                </div>
                <div class="searchGroup">
                    <label>设备类型：</label>
                    <el-select v-model="device_type" placeholder="请选择" @change="getDeviceList">
                        <el-option label="数据采集器" value="1"></el-option>
                        <el-option label="非接触设备" value="2"></el-option>
                    </el-select>
                </div>
                <div class="searchGroup">
                    <label>选择设备：</label>
                    <el-select v-model="device_code" filterable placeholder="请选择">
                        <el-option v-for="item in device_list" :key="item.code"  :label="item.code" :value="item.code"></el-option>
                    </el-select>
                </div>
                <el-button type="primary" plain @click.native="filerData">筛选</el-button>
            </div>
            <el-card class="box-card">
                <div class="mainBody">
                    <div class="btnBox">
                        <Btns :menu_id="menu_id" :menus="main_btns" @on_btnclk="btnClick"></Btns>
                    </div>
                    <div class="dataBox">
                        <el-table :data="tableData" v-loading="loading" border stripe height="700">
                            <el-table-column prop="time" label="时间" width="80">
                                <template slot-scope="scope">
                                    <span>{{ formatDate(scope.row.time, "HH:mm:ss") }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="head_code" label="报文头"></el-table-column>
                            <el-table-column prop="function_code" label="编码"></el-table-column>
                            <el-table-column label="通道1" align="center">
                                <el-table-column prop="volumeIn1" label="进浆流量"></el-table-column>
                                <el-table-column prop="volumeLeak1" label="返浆流量"></el-table-column>
                                <el-table-column prop="pressure1" label="压力"></el-table-column>
                                <el-table-column prop="density1" label="密度"></el-table-column>
                                <el-table-column prop="volumeInException1" label="进浆异常"></el-table-column>
                                <el-table-column prop="volumeLeakException1" label="返浆异常"></el-table-column>
                                <el-table-column prop="pressureException1" label="压力异常"></el-table-column>
                                <el-table-column prop="densityException1" label="密度异常"></el-table-column>
                            </el-table-column>
                            <el-table-column label="通道2" align="center">
                                <el-table-column prop="volumeIn2" label="进浆流量"></el-table-column>
                                <el-table-column prop="volumeLeak2" label="返浆流量"></el-table-column>
                                <el-table-column prop="pressure2" label="压力"></el-table-column>
                                <el-table-column prop="density2" label="密度"></el-table-column>
                                <el-table-column prop="volumeInException2" label="进浆异常"></el-table-column>
                                <el-table-column prop="volumeLeakException2" label="返浆异常"></el-table-column>
                                <el-table-column prop="pressureException2" label="压力异常"></el-table-column>
                                <el-table-column prop="densityException2" label="密度异常"></el-table-column>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="pageBox">
                        <el-pagination background layout="total, sizes,prev, pager, next, jumper" :current-page="current" :page-size="pagesize" :page-sizes="[50, 100, 200]" :total="total" @current-change="pageChange" @size-change="handleSizeChange"></el-pagination>
                    </div>
                </div>
            </el-card>
        </div>
    </div>
</template>

<script>
import Btns from "@/components/common/btns"
import listutil from "@/libs/listutil"
import { filterFileData, exportFileData } from "@/api/messagelog";
import { getAllDeviceCheckList, getAllDeviceExtractList } from "@/api/deviceuser";

export default {
    name: 'messageDataFilter',
    mixins: [listutil],
    components: { Btns},
    data() {
        return {
            m_name: '秒级数据筛选',
            menu_id: 3800,
            list_url: "/api/admin/messagelog/list",
            del_Obj:{
                url:'/api/admin/messagelog/del',
                data:{
                    ids:''
                }
            },
            enu_name: [],
            sortData: {
                prop: 'add_time',
                order: 'descending'
            },
            pagesize: 100,
            allData: [],
            dateRange: [new Date(2016, 9, 10, 0, 0), new Date(2016, 9, 10, 23, 0)],
            start_time: '00:00:00',
            end_time: '05:00:00',
            folder: '',
            device_type: '1',
            device_list: [],
            device_code: '',
        };
    },
    methods: {
        async getData() {
            this.loading = false
            this.getBtnsData();
            this.getDeviceList();
        },
        dateRangeSet(val){
            if(this.$isNotNull(val)){
                this.start_time = val[0]
                this.end_time = val[1]
            }else{
                this.start_time = ''
                this.end_time = ''
            }
        },
        filerData(){
            if (this.$isNull(this.folder)) {
                this.$msg("请选择日期")
                return
            }else if (this.$isNull(this.start_time) || this.$isNull(this.end_time)) {
                this.$msg("请选择时间段")
                return
            }else if (this.$isNull(this.device_code)) {
                this.$msg("请选择设备")
                return
            }
            this.loading = true
            filterFileData(this.folder, this.device_code, this.start_time, this.end_time).then(res=>{
                this.loading = false
                if(res.code == 1){
                    this.allData = res.data
                    this.total = res.data.length
                    this.updateData()
                }else{
                    this.tableData = []
                    this.$msg(res.msg)
                }
            })
        },
        pageChange(page) {
            this.current = page
            this.updateData()
        },
        handleSizeChange(val){
            this.pagesize = val
            this.current = 1
            this.updateData()
        },
        updateData(){
            const startIndex = (this.current - 1) * this.pagesize;
            const endIndex = startIndex + this.pagesize;
            this.tableData = this.allData.slice(startIndex, endIndex);
        },
        export(){
            const loading = this.$loading({
                lock: true,
                text: '正在执行...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            exportFileData(this.folder, this.device_code, this.start_time, this.end_time).then(res=>{
                loading.close()
                if(res.code == 1){
                    window.open(res.data)
                }else{
                    this.$msg(res.msg)
                }
            })
        },
        getDeviceList(){
            if(this.device_type == '1'){
                getAllDeviceCheckList().then(res=>{
                    if(res.code == 1){
                        this.device_list = res.data
                    }
                })
            }else{
                getAllDeviceExtractList().then(res=>{
                    if(res.code == 1){
                        this.device_list = res.data
                    }
                })
            }
        }
    }
};
</script>